import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "next-themes";

import App from "@/App";
import { AuthProvider } from "@/lib/auth";
import { SessionScopeProvider } from "@/lib/session-scope";
import { Toaster } from "@/components/ui/sonner";
import "@/index.css";

// No pinch / double-tap zoom (installed-app feel). iOS Safari ignores user-scalable=no in the
// viewport tag, so block its pinch gesture here; double-tap zoom is off via touch-action in index.css.
document.addEventListener("gesturestart", (e) => e.preventDefault(), { passive: false });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <BrowserRouter>
        <AuthProvider>
          <SessionScopeProvider>
            <App />
            <Toaster position="top-center" />
          </SessionScopeProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>
);
